/**
 * Search Filter Form Container.
 * It helps to filter the Search Result by Document Type.
 * Form is dynamic and it will be generated as per config from file `lib/customFields.js` through `WebForm` Component.
 * The `WebForm` Component internally calls forms components in `public/js/contactUs/components/form`.
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _find from 'lodash/find';

// Components and Shapes.
import { WebForm } from '../../contactUs/components/common/index';
import { WEBFORM_FIELDS_DETAILS } from '../../contactUs/constants/PropTypesShapes';

// Helpers.
import getHistory from '../../lib/HistoryHelper';

// Actions.
import { preserveData } from '../../contactUs/actions/action-search-filters';
import { mobileMenuClose } from '../../contactUs/actions/action-mobile-filter';

// Helpers.
import Page from '../../lib/page';
import i18n from '../../lib/reacti18n';
import { searchMobileButton } from '../../lib/customFields';

// Locales.
const isMobileLayout = Page.isMobileLayout();

class SearchFilterForm extends Component {
  // This Method triggers on Form Field Values Changes with Tracking.
  handleFormSubmit() {
    return (formData) => {
      const history = getHistory();
      const { q } = this.props.queryParams;
      // TODO: update experience with experience for technical experience in URL
      const documentType = _find(formData, { type: 'radio', id: 'docType' }).value;

      // If there is no query and in the mobile filter, then close mobile filter page
      if (!q && isMobileLayout) {
        this.props.mobileMenuClose();
      }
      history.push(`/search?q=${q}&channel=${documentType}`);
    };
  }

  // This Method helps to generate Filter Form through `WebForm` Component.
  getFilterForm() {
    return (
      <div className="panel-block panel panel-default">
        <div className="panel-body">
          <WebForm
            fields={this.props.searchFilters}
            title={i18n.message('smarthelp/searchResult.searchResult.filter.docType.label')}
            handleFieldValue={this.props.preserveData}
            handleSubmit={this.handleFormSubmit()}
            submitOnFieldChange={!isMobileLayout}
          />
        </div>
      </div>
    );
  }

  // Appear the 'Apply Filter' button for the mobile filer page
  addMobileButton() {
    const nonMobileBtn = this.props.searchFilters.every((field) => (field.id !== 'mobileButton'));
    if (isMobileLayout && nonMobileBtn) {
      this.props.searchFilters.push(searchMobileButton);
    }
    if (!isMobileLayout) {
      // hard code splice index to remove the mobile button field form
      this.props.searchFilters.splice(1);
    }
  }

  // Render the SearchFilterForm Container.
  render() {
    this.addMobileButton();
    return (
      <div id="search-filter-form">
        {this.getFilterForm()}
      </div>
    );
  }
}

// Get the Store data and Pass it as Props.
function mapStateToProps(state) {
  return {
    searchFilters: state.searchFilters.fields,
    queryParams: {
      q: state.query.params.q,
    },
  };
}

// SearchFilterForm Props Types.
SearchFilterForm.propTypes = {
  // Complex Prop Types.
  searchFilters: PropTypes.arrayOf(PropTypes.shape(WEBFORM_FIELDS_DETAILS)),
  queryParams: PropTypes.shape({
    q: PropTypes.string,
  }),

  // Method Prop Types.
  preserveData: PropTypes.func.isRequired,
  mobileMenuClose: PropTypes.func.isRequired,
};

// SearchFilterForm Props default values.
SearchFilterForm.defaultProps = {
  searchFilters: [],
  queryParams: undefined,
};

// Dispatch the Action as Props.
function mapDispatchToProps(dispatch) {
  return bindActionCreators({ preserveData, mobileMenuClose }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(SearchFilterForm);
